import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { IDiscrepancyDialog } from "../../interfaces";

export const DiscrepancyDialog: React.FC<IDiscrepancyDialog> = ({
    open,
    readonly,
    handleClose,
    material,
    ...props
}: IDiscrepancyDialog) => {

    useEffect(() => {

        setConfirmRemove(false);
        if (material != null)
            setDiscrepancy(material.discrepancy);

    }, [material])

    const [discrepancy, setDiscrepancy] = useState<string>();
    const [confirmRemove, setConfirmRemove] = useState(false);

    return <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={() => handleClose(material.discrepancy)}
    >
        <DialogTitle>Material Discrepancy</DialogTitle>

        <DialogContent>



            <DialogContentText sx={{ mb: 2 }}>
                {!readonly && "If the material recieved does not match the details in this storage request, please note the differences below."}
            </DialogContentText>



            <TextField
                label="Discrepancies"
                multiline
                fullWidth
                rows={4}
                value={discrepancy}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setDiscrepancy(e.target.value) }}
                disabled={readonly}
                helperText={readonly ? "submitted discrepancies can not be amended." : undefined}
            />



        </DialogContent>
        <DialogActions>

            {readonly ? <Button onClick={() => handleClose(undefined)}>Close</Button> :
                <>
                    <Box width="100%" display="flex" justifyContent="space-between">

                        {(material?.undelivered !== true) && confirmRemove ?
                            <Box>
                                <Typography color="error" sx={{ mx: 1 }} variant="subtitle1">Remove this material?</Typography>
                            </Box>
                            :
                            <Box>
                                {material?.undelivered === true ?
                                    <Chip sx={{ mx: 1 }} label="Material was not delivered" color="error" variant="outlined" size="small" />
                                    :
                                    <Button color="error" onClick={() => setConfirmRemove(true)} >Not Delivered</Button>
                                }
                            </Box>
                        }


                        {confirmRemove ?
                            <Box>
                                <Button color="primary" onClick={() => setConfirmRemove(false)} >Cancel</Button>
                                <Button color="error" onClick={() => handleClose(discrepancy, true)} >Remove</Button>

                            </Box>
                            :
                            <Box>
                                <Button color="warning" onClick={() => handleClose(undefined)} >Clear</Button>
                                <Button color="primary" onClick={() => handleClose(discrepancy)}>Update</Button>
                            </Box>
                        }
                    </Box>
                </>
            }
        </DialogActions>
    </Dialog >
}